export const getRegistryImage = registryName => {
  const images = {
    'Universal Carbon Registry': '/images/registries/UCR.svg',
    'Climate Action Reserve': '/images/registries/CAR.png',
    UNFCCC: '/images/registries/UNFCCC.png',
    'ICR (International Carbon Registry)': '/images/registries/ICR.png',
    Verra: '/images/registries/VERRA.svg',
    'Gold Standard': '/images/registries/gold_standard.svg',
    'GCC (Global Carbon Council)': '/images/registries/GCC.png',
    'Plan Vivo': '/images/registries/PLAN_VIVO.svg',
    'American Carbon Registry': '/images/registries/american_carbon.svg',
    'IREC (International Renewable Energy Certificate)':
      '/images/registries/IREC.png'
  }

  return images[registryName]
}
